import { ReferenceEntity } from './types/reference.type';

export const referenceTracker = {
  performDeleteOrShowWarning: (entity: ReferenceEntity, onDelete: () => void): void => {
    return referenceTracker.performDeleteOrShowWarning(entity, onDelete);
  },

  checkReferencePresent: (entity: ReferenceEntity): boolean => {
    return referenceTracker.checkReferencePresent(entity) ?? false;
  },
};
